module.exports = __webpack_public_path__ + "fonts/Graphik-Black-Web.6a510fd.woff";